import { TeamMember } from 'src/api/workspacesAPI';

type MemberLike = Pick<TeamMember, 'email'> & Partial<Pick<TeamMember, 'displayName' | 'fullName'>>;

export const getMemberDisplayName = (member?: MemberLike | null): string => {
  if (!member) {
    return '';
  }

  return member.displayName || member.fullName || member.email || '';
};

export default getMemberDisplayName;
